import React, { useEffect, useState } from 'react';
import '../App.css';
import {db} from '../firebase.js'
import {collection, getDocs} from 'firebase/firestore'

function About() {

    const [intro, setIntro] = useState([]);
    const [skills, setSkills] = useState([]);
    const [closing, setClosing] = useState([]);

    useEffect(() => {
        const fetchAbout = async () => {
            const querySnapshot = await getDocs(collection(db,"about"))
            const aboutData = querySnapshot.docs.map(doc =>doc.data());
            aboutData.map((about) => {
                if((about.closing_note) !== undefined){
                    setClosing(about.closing_note);
                } else if((about.skills) !== undefined){
                    setSkills(about.skills);
                } else if((about.intro) !== undefined){
                    setIntro(about.intro);
                }
            })
            //(aboutData)
        };

        fetchAbout()
    }, []);
    
    console.log(skills)
    

    return (
        <section id="about">
            <h2>About Me</h2>
            <p>{intro}</p>
            <ul>
                {Object.entries(skills).map(([skill, description]) => 
                    (
                        <li><strong>{skill}</strong>: {description}</li>
                    )
                )}
                {/* <li><strong>Spring Boot</strong>: Building robust and scalable backend applications.</li>
                <li><strong>Django</strong>: Developing efficient and secure web applications.</li>
                <li><strong>Machine Learning</strong>: Implementing innovative solutions to complex problems.</li> */}
            </ul>
            <p>{closing}</p>
        </section>
    );
}

export default About;
